import type { POI } from "../types";
import poisJson from "./pois.json";

/**
 * Lista completa dei POI nel nuovo schema.
 * I dati vivono in pois.json (generato da scripts/migrate.mjs).
 * Editare a mano il JSON, non questo file.
 */
export const pois: POI[] = poisJson as POI[];

/** @deprecated alias per retrocompatibilita' temporanea. */
export const pointsOfInterest = pois;
